import React from 'react';
import ProductSystemTableRowRohr from './ProductSystemTableRowRohr'

import ProductSystemTableRowKabel from './ProductSystemTableRowKabel'

const productSystemTableRow = (props) => {

  const colLayer = (layer) => {
    return (layer !== null && layer !== "" && layer !== undefined) ?
      " (" + layer + ")" :
      ""
  }

  const colAnzahl = (minVal, maxVal) => {
    let val = ((minVal === maxVal && minVal === 1) || (minVal === null && maxVal === null)) ?
      "" :
      " (" + minVal + "-" + maxVal + ")"
    return val;
  }

  const fromToValue = (minVal, maxVal) => {
    let val = ""
    if (minVal === maxVal) {
      val = maxVal
    } else if (minVal !== maxVal && minVal > 0) {
      val = minVal + "-" + maxVal
    } else if (minVal !== maxVal && parseInt(minVal, 10) === 0) {
      val = "≤ " + maxVal
    }
    return (val !== null) ?
      val.replace(/\./g, ",") :
      ""
  }

  const maxBreiteMaxHoehe = (maxBreite, maxHoehe) => {
    return  "≤ " + parseInt(maxBreite, 10) + " x ≤ " + parseInt(maxHoehe, 10)
  }


  // Unendlichkeitszeichen
  const fromToValueUnendlich = (minVal, maxVal) => {
    maxVal = (maxVal === "1000.0") ? " ∞" : maxVal
    let val = (minVal === maxVal) ? maxVal : minVal + "-" + maxVal
    return (val !== null) ? val.replace(/\./g, ",") : ""
  }

  const colFwk = (classification, tube_configuration) => {
    let val = ""

    if ((classification !== "" && classification !== null && classification !== undefined )) {
      val = classification
      if ((tube_configuration !== "" && tube_configuration !== null && tube_configuration !== undefined )) {
        val = val + " " + tube_configuration
      }
    }
    if (val !== "") {
      val = "EI " + val
    }
    return val;
  }

  const colDiameter = (item) => {
    if (item.medium_type === "lue_e") {
      return maxBreiteMaxHoehe(item.max_width_lueftung, item.max_height_lueftung)
    } else {
      return fromToValue(item.diameter_min, item.diameter_max)
    }
  }

  const components = {
          tube: ProductSystemTableRowRohr,
          cable: ProductSystemTableRowKabel,
      };

  const TableType = () => {
    const CompName = components[props.tableType]
    return <CompName
      globalGap={props.globalGap}
      onToggle={props.onToggle}
      amount={props.amount}
      colFwk={colFwk}
      colDiameter={colDiameter(props.item)}
      colLayer={colLayer}
      colAnzahl={colAnzahl}
      fromToValue={fromToValue}
      fromToValueUnendlich={fromToValueUnendlich}
      color={props.color}
      item={props.item}
      isSelected={props.isSelected}
      onAdd={props.onAdd}
      onSubstract={props.onSubstract}
      />
  };

  return TableType()
};

export default productSystemTableRow;



// WEBPACK FOOTER //
// ./src/components/Shared/ProductSystemTableRow.js